import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22e30fd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userInfoView" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = {
  key: 0,
  class: "arco-upload-list-picture custom-upload-avatar"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "arco-upload-list-picture-mask" }

import { useStore } from "vuex";
import { ref } from "vue";
import { FileItem, Message } from "@arco-design/web-vue";
import { useRouter } from "vue-router";
import moment from "moment";
import {
  UserControllerService,
  UserUpdateMyRequest,
} from "../../../backend/user";
import { Service } from "../../../backend/file";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoView',
  setup(__props) {

const router = useRouter();
const file = ref();
/**
 * 获取用户信息
 */
const store = useStore();
let loginUser = store.state.user.loginUser;

const data = [
  {
    label: "用户名称：",
    value: loginUser.userName,
  },
  {
    label: "账号名称：",
    value: loginUser.userAccount,
  },
  {
    label: "我的简介：",
    value: loginUser.userProfile,
  },
  {
    label: "用户角色：",
    value: loginUser.userRole === "user" ? "普通用户" : "管理员",
  },
  {
    label: "邮箱：",
    value: loginUser.email !== "" ? loginUser.email : "未填写",
  },
  {
    label: "电话：",
    value: loginUser.phone !== "" ? loginUser.phone : "未填写",
  },
  {
    label: "当前状态：",
    value: loginUser.userState !== "" ? loginUser.userState : "暂无简介",
  },

  {
    label: "创建时间：",
    value: moment(loginUser.createTime).format("YYYY-MM-DD HH:mm:ss"),
  },
  {
    label: "修改时间：",
    value: moment(loginUser.updateTime).format("YYYY-MM-DD HH:mm:ss"),
  },
];

const visible = ref(false);
const updateForm = ref<UserUpdateMyRequest>({
  ...store.state.user?.loginUser,
});

// 从表单中获取的用户头像
let userAvatarImg = updateForm.value.userAvatar;

/**
 * 上传头像
 */
const uploadAvatar = async () => {
  const res = await Service.uploadCosFileUsingPost(file?.value.file);
  if (res.code === 0) {
    userAvatarImg = res.data;
    Message.success("上传成功，点击确认即可修改头像");
  } else {
    Message.error("上传失败！" + res.data);
  }
};
/**
 * 打开弹窗
 */
const openModalForm = () => {
  visible.value = true;
};
/**
 * 确定修改按钮
 */
const handleOk = async () => {
  const res = await UserControllerService.updateMyUserUsingPost({
    ...updateForm.value,
    userAvatar: userAvatarImg,
  });
  if (res.code === 0) {
    Message.success("更新成功！");
    visible.value = false;
    location.reload();
  } else {
    Message.error("更新失败！", res.msg);
  }
};
const closeModel = () => {
  visible.value = false;
};
/**
 * 回到首页
 * @param question
 */
const toIndex = () => {
  router.push({
    path: `/`,
  });
};
const onChange = async (_: never, currentFile: FileItem) => {
  file.value = {
    ...currentFile,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_descriptions_item, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_avatar, {
          size: 100,
          shape: "circle"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(loginUser).userAvatar,
              alt: "头像"
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { title: "我的信息" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_badge, {
          status: "success",
          text: "在线"
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          data: data,
          bordered: "",
          column: "1",
          size: "large"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      placement: "right",
      unmountOnClose: "",
      width: "30%",
      onCancel: closeModel,
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_upload, {
            "custom-request": uploadAvatar,
            fileList: file.value ? [file.value] : [],
            "show-file-list": false,
            action: "/",
            onChange: onChange
          }, {
            "upload-button": _withCtx(() => [
              (updateForm.value.userAvatar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_a_avatar, {
                      size: 70,
                      shape: "circle"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(userAvatarImg),
                          alt: "头像"
                        }, null, 8, _hoisted_5)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_IconEdit)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["fileList"])
        ]),
        _createVNode(_component_a_form, {
          model: _unref(loginUser),
          "label-align": "right",
          style: {"max-width":"480px","margin":"0 auto"},
          title: "个人信息"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "用户名称",
              label: "账号 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: updateForm.value.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((updateForm.value.userName) = $event)),
                  placeholder: "请输入用户名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "邮箱",
              label: "邮箱 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: updateForm.value.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateForm.value.email) = $event)),
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "电话",
              label: "电话 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: updateForm.value.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((updateForm.value.phone) = $event)),
                  placeholder: "请输入电话号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userProfile",
              label: "简介 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  modelValue: updateForm.value.userProfile,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateForm.value.userProfile) = $event)),
                  placeholder: "请输入简介"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        shape: "round",
        size: "small",
        status: "success",
        style: {"margin":"10px"},
        type: "outline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_link, { onClick: toIndex }, {
            default: _withCtx(() => [
              _createTextVNode("首页")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        shape: "round",
        size: "medium",
        status: "normal",
        style: {"margin":"10px"},
        type: "outline",
        onClick: openModalForm
      }, {
        default: _withCtx(() => [
          _createTextVNode("修改用户信息 ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})